module.exports = __webpack_public_path__ + "img/casas-bahia-logo.c100998d.png";